import { generateQueryParams } from 'utils/common-functions';
import CommonService from './common.service';

class MediaService extends CommonService {
  async getMedia(params?: { [key: string]: string | boolean }) {
    const query = generateQueryParams(params);
    return await this.get(`users/?${query}`);
  }

  async deleteMedia(id: string) {
    return await this.delete(`media/${id}`)
  }

  async postMedia(parmas: { [key: string]: boolean | string }) {
    return await this.post('media', parmas)
  }
}

export const mediaService = new MediaService();

